/**
 * Variantes para el "chrome" del action bar del álbum: el label "SELECCIÓN",
 * la barra de progreso, el buscador inline y los chips de selección.
 *
 * Cada variant define `accent` (color principal) y un `chipMode` que
 * controla cómo se pintan los chips (y los prefijos del dropdown del
 * buscador):
 *   - 'unified': todos usan `accent`.
 *   - 'country': cada chip toma el color de la bandera del país.
 */

const GOLD_MID = '#d4af37';
const GOLD_DARK = '#8c6d1f';

export const CHROME_VARIANT_NAMES = [
  'Neutro',
];

export const CHROME_DEFAULT_IDX = 0;

export function getChromeVariant(idx) {
  // Sólo queda el variant Neutro (gris). Mantenemos el GOLD_* para no
  // romper imports si en el futuro se vuelve a habilitar otra paleta.
  void GOLD_MID; void GOLD_DARK;
  return {
    accent: '#475569',
    accentDeep: '#1e293b',
    gradient: null,
    shimmer: false,
    chipMode: 'country',
    textOnGradient: '#ffffff',
  };
}
